import React, { useState } from 'react';
import { Modal, Form, DatePicker, Input, App } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { workOrderApi } from '../../../services/api';
import { WorkOrder } from '../../../types';

interface SetEtaModalProps {
  workOrder: WorkOrder;
  open: boolean;
  onClose: () => void;
  onSaved: () => void;
}

const SetEtaModal: React.FC<SetEtaModalProps> = ({ workOrder, open, onClose, onSaved }) => {
  const { message } = App.useApp();
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  const handleOk = async () => {
    const values = (await form.validateFields()) as { eta?: Dayjs; supplier?: string };
    setSaving(true);
    try {
      await workOrderApi.updatePartsStatus(workOrder.id!, {
        parts_eta: values.eta ? values.eta.format('YYYY-MM-DD') : null,
        parts_supplier: values.supplier ?? null,
      });
      message.success('Parts ETA updated');
      onSaved();
    } catch {
      message.error('Failed to update parts ETA');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title="Update Parts ETA"
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      confirmLoading={saving}
      okText="Save"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          eta: workOrder.parts_eta ? dayjs(workOrder.parts_eta) : undefined,
          supplier: workOrder.parts_supplier ?? undefined,
        }}
      >
        <Form.Item name="eta" label="Expected arrival">
          <DatePicker style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="supplier" label="Supplier">
          <Input placeholder="e.g. RockAuto" maxLength={200} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SetEtaModal;
